import { Fragment, memo, ReactElement } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import Form from './form';
import { ParenthoodSearchForm } from 'subscription/view-models/common-interface-subscription';

interface AccordionFilterProps {
  onChange: (
    key: keyof ParenthoodSearchForm,
    value: ParenthoodSearchForm[keyof ParenthoodSearchForm]
  ) => void;
  values?: ParenthoodSearchForm;
  disabled?: boolean;
  onChangeFields: (values: ParenthoodSearchForm | null) => void;
  resetForm: () => void;
  onSearch: () => void;
  setOpen: (value: boolean) => void;
  open?: boolean;
}

const AccordionFilterComponent = ({
  onChange,
  values,
  disabled,
  onChangeFields,
  onSearch,
  setOpen,
  open,
  resetForm,
}: AccordionFilterProps): ReactElement => {
  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter"
          id="filter"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form
            onChange={onChange}
            values={values}
            disabled={disabled}
            onChangeFields={onChangeFields}
            onSearch={onSearch}
            resetForm={resetForm}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFilterComponent.displayName = 'Filter person';

const AccordionFilterPerson = memo(AccordionFilterComponent);

export default AccordionFilterPerson;
